import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

/**
 * v2.6.9 batch BF-3 · ConfigContext now exposes `reload()` so callers can force
 * a fresh /api/config fetch (e.g. after admin saves new pricing rates, or when
 * a page mounts that must reflect the latest admin-side edits).
 */
const ConfigContext = createContext({ config: null, loading: true, reload: async () => {} });

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    try {
      const r = await api.get("/config", { params: { _: Date.now() } });
      setConfig(r.data);
      return r.data;
    } catch (err) {
      console.warn("/config fetch failed", err?.response?.status);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const value = useMemo(() => ({ config, loading, reload }), [config, loading, reload]);
  return <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>;
}

export const useConfig = () => useContext(ConfigContext);
